import {
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss'],
})
export class DeleteUserComponent implements OnDestroy {
  @Input() user: any;
  @Input() currentUser: any;
  @Output() modalState = new EventEmitter<{
    isDelete: boolean;
    isUpdate: boolean;
  }>();

  constructor(
    private userService: UserService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {}
  private destroy = new Subject<boolean>();

  deleteUser() {
    this.userService
      .deleteUser(this.user.id)
      .pipe(takeUntil(this.destroy))
      .subscribe({
        next: () => {
          this.modalState.emit({ isDelete: true, isUpdate: true });
          this.toastr.success('User successfully deleted', 'Success');
          if (this.currentUser && this.currentUser.id === this.user.id) {
            this.authService.logout();
          }
        },
        error: (err) => {
          this.closeModal();
        },
      });
  }

  closeModal() {
    this.modalState.emit({ isDelete: false, isUpdate: false });
  }

  backdropClick(event: Event) {
    if (event.target === event.currentTarget) {
      this.modalState.emit({ isDelete: false, isUpdate: false });
    }
  }

  ngOnDestroy(): void {
    this.destroy.next(true);
    this.destroy.complete();
  }
}
